export interface MensagemHistorico {
  id: string;
  texto: string;
  tipo: "usuario" | "assistente";
  artigos?: any[];
  whatsapps?: any[];
  idRespostaGptSak?: number | null;
  feedback?: "sim" | "nao";
  anexoTexto?: string;
  // Respostas da IA da central (api/conversar.ts).
  opcoes?: string[];
  artigoUsado?: string | null;
  precisaHumano?: boolean;
  resumoCaso?: string;
  fonte?: "ia";
  artigoUsadoTitulo?: string | null;
  artigoHtml?: string | null;
}

// Mensagens que a própria interface grava em nome do usuário (ex.: "Preciso de mais ajuda.").
// Não entram no resumo como se fossem a dúvida dele.
export const ehMensagemDaInterface = (texto: string, textosInterface: string[]) =>
  textosInterface.includes(texto);

export interface ResumoConversa {
  duvida: string;
  detalhes: string[];
  respostasIa: number;
  naoResolveu: boolean;
  textoPrint: string;
}

export const resumirConversa = (
  historico: MensagemHistorico[],
  textosInterface: string[]
): ResumoConversa => {
  const doUsuario = historico
    .filter((m) => m.tipo === "usuario" && !ehMensagemDaInterface(m.texto, textosInterface))
    .map((m) => m.texto);
  const respostas = historico.filter(
    (m) => m.tipo === "assistente" && m.texto !== "pediu_ajuda"
  );

  return {
    duvida: doUsuario[0] || "",
    detalhes: doUsuario.slice(1, 4),
    respostasIa: respostas.length,
    naoResolveu: respostas.some((m) => m.feedback === "nao"),
    textoPrint:
      historico.filter((m) => m.tipo === "usuario" && m.anexoTexto).pop()?.anexoTexto || "",
  };
};

// Pergunta do usuário que originou a resposta de índice `indice` (ignora as mensagens da interface).
export const perguntaOriginalDe = (
  historico: MensagemHistorico[],
  indice: number,
  textosInterface: string[]
) => {
  for (let i = indice - 1; i >= 0; i--) {
    const m = historico[i];
    if (m.tipo === "usuario" && !ehMensagemDaInterface(m.texto, textosInterface)) {
      // Com print anexado, a nova tentativa leva o texto do print junto.
      return m.anexoTexto ? `${m.texto}\n\n${m.anexoTexto}` : m.texto;
    }
  }
  return "";
};
